import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'

@observer
export default class RemoveAiQuestion extends Component {
    constructor(props) {
        super(props)
        const { store } = this.props
        this.appStore = store
    }

    close = (e) => {
        e?.preventDefault()
        this.appStore.aiQuestions.removeModalOpen = false
    }

    continue = (e) => {
        e.preventDefault()
        this.appStore.aiQuestions.remove()
        this.close()
    }

    render() {
        return (
            <Modal
                show={this.appStore.aiQuestions.removeModalOpen}
                onClose={this.close}
            >
                <div id="remove-ai-modal">
                    <div className="uc-modal__header">
                        <h2>{i18n.t('surveyBuilder.modal.removeAiConfirmation.title')}</h2>
                        <p className="uc-modal__desc">
                            {i18n.t('surveyBuilder.modal.removeAiConfirmation.desc')}
                        </p>
                    </div>
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={this.close}
                            cssClass="tertiary"
                            label={i18n.t('cancel')}
                        />
                        <Button
                            onClick={this.continue}
                            cssClass="secondary"
                            label={i18n.t('continue')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}
